<template>
  <div>
    <NavBar :narBarTitle="$t('登录')" :showLogo="true" :companyCode="companyCode.code" :companyLogo="companyLogo" />

    <Verify ref="verify" :captcha-type="'blockPuzzle'" :img-size="{ width: '300px', height: '150px' }"
      @success="onVerifySuccess" />

    <van-tabs title-inactive-color="#CCCCCC" line-height="0" v-model="active">
      <van-tab :title="$t('验证码登录')">
        <van-form class="loginForm">
          <div class="errSpace">
            <van-field v-model="mobile" clearable name="mobile" class="form-spacing form-spacing-code"
              :placeholder="$t('请输入手机号')" :rules="[{ required: true }]" @blur="verifyMobile" />
            <!-- <span v-show="mobileErr" class="error">请输入正确的手机号</span> -->
          </div>
          <div class="errSpace">
            <van-field v-model="code" center clearable name="code" class="form-spacing form-spacing-code"
              :placeholder="$t('请输入验证码')" maxlength="6">
              <template #button>
                <van-button size="small" type="info" :disabled="!modelSms" @click="onSendVerfiy" class="code-btn"
                  :style="{ color: smsColor ? '#009BFF' : '#CCCCCC' }">{{ smsTitle }}</van-button>
              </template>
            </van-field>
          </div>
          <div @click="toReg" class="to-login" v-show="ifCompanyCode" v-if="showRegisterBtn">
            {{ $t('立即注册') }}
          </div>
          <div class="loginBox">
            <van-button round block type="info" native-type="submit" :disabled="!codeLoginTest" class="login-btn"
              :style="{ background: codeLoginTest ? '#009BFF' : '#DDDDDD' }" @click="onLogin">{{ $t('登录')
              }}</van-button>
          </div>
        </van-form>
      </van-tab>
      <van-tab :title="$t('密码登录')">
        <van-form @submit="onLogin" class="loginForm">
          <div class="errSpace">
            <van-field v-model="mobile" clearable name="mobile" :placeholder="$t('请输入用户名/手机号')"
              :rules="[{ required: true }]" />
            <span class="error"></span>
          </div>
          <div class="errSpace">
            <van-field v-model="password" :type="seen ? 'password' : 'text'" center clearable name="password"
              class="form-spacing" :placeholder="$t('请输入密码')" autocomplete="“off”"
              :rules="[{ required: true, validator: pwdTest }]" @blur="verifyPwd">
              <template #right-icon>
                <div @click="changeSeen" class="code-btn">
                  <img v-if="eye" src="@/assets/images/invisible.png" alt="" />
                  <img v-else src="@/assets/images/visible.png" alt="" />
                </div>
              </template>
            </van-field>
            <span v-show="pwdErr" class="error">{{
              $t('请输入正确的密码')
            }}</span>
          </div>
          <div class="jumpBox" v-show="ifCompanyCode">
            <div @click="toReg" class="to-login" v-if="showRegisterBtn">
              {{ $t('立即注册') }}
            </div>
            <div @click="tofindPwd" class="to-findPwd ml-auto">
              {{ $t('忘记密码') }}
            </div>
          </div>
          <div class="loginBox">
            <van-button round block type="info" native-type="submit" :disabled="!pwdLoginTest" class="login-btn"
              :style="{ background: pwdLoginTest ? '#009BFF' : '#DDDDDD' }">{{ $t('登录') }}</van-button>
          </div>
        </van-form>
      </van-tab>
    </van-tabs>
    <!-- <van-number-keyboard
      v-model="code"
      :show="showKeyboardCode"
      @blur="showKeyboardCode = false"
      safe-area-inset-bottom
    /> -->
  </div>
</template>
<script>
import Vue from 'vue'
import {
  pwdLogin,
  getVerifyCode,
  codeLogin,
  bindWechat,
  codeLoginByDing,
  pwdLoginByDing,
  autoLogin,
  getCompanyInfo,
  ovWxAutoLogin,
  fwAutoLogin,
} from '@/services/api'
import { getCode, ifInDD } from '@/utils/getDingCode.js'
import NavBar from '@/components/navBar'
import Verify from '@/components/verifition/Verify'
import { LocaleMgr } from 'i18n'

import {
  Form,
  Field,
  Button,
  Toast,
  Icon,
  Tab,
  Tabs,
  NumberKeyboard,
  Dialog
} from 'vant'

Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(NumberKeyboard)

export default {
  name: 'Login',
  components: {
    NavBar,
    Verify,
  },
  data() {
    return {
      mobile: '',
      code: '',
      password: '',
      smsTitle: this.$t('获取验证码'),
      seen: true,
      eye: true,
      mobileErr: false,
      pwdErr: false,
      showKeyboardCode: false,
      companyCode: {},
      corpId: '',
      wxcode: '',
      ddCode: '',
      ifCompanyCode: true,
      companyLogo: '',
      openId: '',
      curAccountInfo: {}, // 记录用户当前填写的登录信息
      active: 0, // tab选中的index
      showRegisterBtn: false, //显示隐藏立即注册
    }
  },
  methods: {
    onSend() {
      let time = 60
      this.smsTitle = time + 's'
      const t = setInterval(() => {
        if (time === 1) {
          clearInterval(t)
          this.smsTitle = this.$t('重新获取')
        } else {
          time--
          this.smsTitle = time + 's'
        }
      }, 1000)
      getVerifyCode({
        mobile: this.mobile,
        plate: 'NEW_WORK',
        time: 600,
      })
    },
    handleLogin(data) {
      {
        const userLanguage = data?.userLanguage
        userLanguage && localStorage.setItem('userLanguage', userLanguage)

        LocaleMgr.singleton.setLocale()
      }
      localStorage.setItem('user', JSON.stringify(data))
      localStorage.setItem('cCode', JSON.stringify(this.companyCode))
      localStorage.setItem('companyCode', JSON.stringify(this.companyCode))
      let check = JSON.parse(localStorage.getItem('checkMeeting'))
      let appointmentId = JSON.parse(localStorage.getItem('appointmentId'))
      if (check) {
        if (check.isTemplateSend) {
          this.$router.replace(
            `templateSend?appointmentId=${appointmentId.id}&companyCode=${this.companyCode.code}`
          )
        }
        if (check.isTemplateSendSpecial) {
          this.$router.replace(
            `templateSendSpecial?appointmentId=${appointmentId.id}&companyCode=${this.companyCode.code}`
          )
        }
        localStorage.removeItem('checkMeeting')
        localStorage.removeItem('appointmentId')
        return
      }
      this.ifBind(data)
      if (data.name) {
        this.$router.replace('/').catch((err) => err)
      } else {
        this.$router.replace('bindCompany')
      }
    },
    onSendVerfiy() {
      this.$refs.verify.show()
    },
    toReg() {
      this.$router.replace(
        `/reg?companyCode=${this.$route.query.companyCode || this.companyCode.code
        }`
      )
    },
    tofindPwd() {
      this.$router.replace(
        `/findPwd?companyCode=${this.$route.query.companyCode || this.companyCode.code
        }`
      )
    },
    onLogin(v) {
      if (this.active === 0) {
        const curAccountInfo = {
          mobile: this.mobile,
          code: this.code,
        }
        this.onCodeLogin(curAccountInfo)
        this.curAccountInfo = curAccountInfo
      } else {
        this.curAccountInfo = v
        this.$refs.verify.show()
      }
    },
    onVerifySuccess() {
      if (this.active === 0) {
        this.onSend()
      } else if (this.active === 1) {
        this.onPwdLogin(this.curAccountInfo)
      }
    },
    async onPwdLogin(v) {
      let res
      if (this.corpId) {
        // console.log(this.companyCode.code)
        let loginByDing = async (code) => {
          try {
            res = await pwdLoginByDing({
              companyCode: this.companyCode.code,
              dingTalkUserId: code,
              ...v,
            })
            this.handleLogin(res)
          } catch (error) {
            Toast.fail(error.response.data.message)
          }
        }
        getCode((code) => {
          loginByDing(code)
        }, this.corpId)
      } else {
        try {
          res = await pwdLogin({
            companyCode: this.companyCode.code,
            ...v,
          })
          this.handleLogin(res)
        } catch (error) {
          Toast.fail(error.response.data.message)
        }
      }
    },
    async onCodeLogin(v) {
      let res
      if (this.corpId) {
        let loginByDing = async (code) => {
          try {
            res = await codeLoginByDing({
              companyCode: this.companyCode.code,
              dingTalkUserId: code,
              ...v,
            })
            this.handleLogin(res)
          } catch (error) {
            Toast.fail(error.response.data.message)
          }
        }
        getCode((code) => {
          loginByDing(code)
        }, this.corpId)
      } else {
        try {
          res = await codeLogin({
            companyCode: this.companyCode.code,
            ...v,
          })
          this.handleLogin(res)
        } catch (error) {
          Toast.fail(error.response.data.message)
        }
      }
    },
    async ifBind(res) {
      if (this.wxcode) {
        if (!res.wechatOpenId) {
          await bindWechat({
            companyCode: this.companyCode.code,
            mobile: this.mobile,
            // code: this.wxcode,
            openId: this.openId,
          })
        }
      }
      // if (this.corpId) {
      //   if (!res.dingTalkUserId) {
      //     await getCode(
      //       code => {
      //         this.ddCode = code
      //       },
      //       this.corpId,
      //       res.companyId,
      //       res.id
      //     )
      //     localStorage.removeItem('corpid')
      //   }
      // }
    },
    mobileTest() {
      return /^1[3-9]\d{9}$/.test(this.mobile)
    },
    codeTest() {
      return this.code.length > 0
    },
    pwdTest() {
      return this.password.length > 5
    },
    changeSeen() {
      this.seen = !this.seen
      this.eye = !this.eye
    },
    verifyMobile() {
      if (this.mobileTest()) {
        this.mobileErr = false
      } else {
        this.mobileErr = true
      }
    },
    verifyPwd() {
      if (this.pwdTest()) {
        this.pwdErr = false
      } else {
        this.pwdErr = true
      }
    },
    async ifYongYouLogin(code, companyCode) {
      let res = await autoLogin({
        yongYouOpenCode: code,
        companyCode: companyCode,
      })
      if (res.id != -1) {
        localStorage.setItem('user', JSON.stringify(res))
        let companyCodeLocal = { code: companyCode }
        localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
        localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
        if (res.name) {
          let check = JSON.parse(localStorage.getItem('checkMeeting'))
          let appointmentId = JSON.parse(localStorage.getItem('appointmentId'))
          if (check) {
            if (check.isTemplateSend) {
              this.$router.replace(
                `templateSend?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
              )
            }
            if (check.isTemplateSendSpecial) {
              this.$router.replace(
                `templateSendSpecial?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
              )
            }
            localStorage.removeItem('checkMeeting')
            localStorage.removeItem('appointmentId')
            return
          }
          localStorage.removeItem('code')
          this.$router.replace('/').catch((err) => err)
        } else {
          this.$router.replace('bindCompany')
        }
      } else {
        let companyCode =
          localStorage.getItem('companyCode') &&
            JSON.parse(localStorage.getItem('companyCode')).code
            ? JSON.parse(localStorage.getItem('companyCode'))
            : { code: this.$route.query.companyCode }
        if (companyCode && companyCode.code) {
          this.companyCode = companyCode
          const companyInfo = await getCompanyInfo(companyCode.code)
          if (companyInfo.logo) {
            this.companyLogo = companyInfo.logo
          } else {
            this.companyLogo = require('@/assets/images/logo.png')
          }
        } else {
          this.ifCompanyCode = false
          this.companyLogo = require('@/assets/images/logo.png')
          return
        }
      }
    },
    async ifFanWeiLogin(companyCode) {
      const { loginId, stamp, token } = this.$route.query
      const isFwAutoLogin = await fwAutoLogin({ loginId, sjc: stamp, token })
      if (isFwAutoLogin) {
        const res = await autoLogin({ companyCode, zyStaffCode: loginId })
        if (res.id != -1) {
          localStorage.setItem('user', JSON.stringify(res))
          let companyCodeLocal = { code: companyCode }
          localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
          localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
          if (res.name) {
            let check = JSON.parse(localStorage.getItem('checkMeeting'))
            let appointmentId = JSON.parse(
              localStorage.getItem('appointmentId')
            )
            if (check) {
              if (check.isTemplateSend) {
                this.$router.replace(
                  `templateSend?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
                )
              }
              if (check.isTemplateSendSpecial) {
                this.$router.replace(
                  `templateSendSpecial?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
                )
              }
              localStorage.removeItem('checkMeeting')
              localStorage.removeItem('appointmentId')
              return
            }
            localStorage.removeItem('code')
            this.$router.replace('/').catch((err) => err)
          } else {
            this.$router.replace('bindCompany')
          }
        } else {
          let companyCode =
            localStorage.getItem('companyCode') &&
              JSON.parse(localStorage.getItem('companyCode')).code
              ? JSON.parse(localStorage.getItem('companyCode'))
              : { code: this.$route.query.companyCode }
          if (companyCode && companyCode.code) {
            this.companyCode = companyCode
            const companyInfo = await getCompanyInfo(companyCode.code)
            if (companyInfo.logo) {
              this.companyLogo = companyInfo.logo
            } else {
              this.companyLogo = require('@/assets/images/logo.png')
            }
          } else {
            this.ifCompanyCode = false
            this.companyLogo = require('@/assets/images/logo.png')
            return
          }
        }
      }
    },
    async ifHuDongLogin(companyCode) {
      const { loginId, stamp, token } = this.$route.query

      const isHdAutoLogin = await fwAutoLogin({ loginId, sjc: stamp, token })
      if (isHdAutoLogin) {
        const res = await autoLogin({ companyCode, hdUserId: loginId })
        if (res.id != -1) {
          localStorage.setItem('user', JSON.stringify(res))
          let companyCodeLocal = { code: companyCode }
          localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
          localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
          if (res.name) {
            let check = JSON.parse(localStorage.getItem('checkMeeting'))
            let appointmentId = JSON.parse(
              localStorage.getItem('appointmentId')
            )
            if (check) {
              if (check.isTemplateSend) {
                this.$router.replace(
                  `templateSend?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
                )
              }
              if (check.isTemplateSendSpecial) {
                this.$router.replace(
                  `templateSendSpecial?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
                )
              }
              localStorage.removeItem('checkMeeting')
              localStorage.removeItem('appointmentId')
              return
            }
            localStorage.removeItem('code')
            this.$router.replace('/').catch((err) => err)
          } else {
            this.$router.replace('bindCompany')
          }
        } else {
          let companyCode =
            localStorage.getItem('companyCode') &&
              JSON.parse(localStorage.getItem('companyCode')).code
              ? JSON.parse(localStorage.getItem('companyCode'))
              : { code: this.$route.query.companyCode }
          if (companyCode && companyCode.code) {
            this.companyCode = companyCode
            const companyInfo = await getCompanyInfo(companyCode.code)
            if (companyInfo.logo) {
              this.companyLogo = companyInfo.logo
            } else {
              this.companyLogo = require('@/assets/images/logo.png')
            }
          } else {
            this.ifCompanyCode = false
            this.companyLogo = require('@/assets/images/logo.png')
            return
          }
        }
      }
    },
    ifautoLogin(corpid, companyCode) {
      let dingAutoLogin = async (dingTalkUserId) => {
        const res = await ovWxAutoLogin({
          companyCode: companyCode,
          dingTalkUserId: dingTalkUserId,
        })
        if (res.id != -1) {
          localStorage.setItem('user', JSON.stringify(res))
          let companyCodeLocal = { code: companyCode }
          localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
          localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
          if (res.name) {
            let check = JSON.parse(localStorage.getItem('checkMeeting'))
            let appointmentId = JSON.parse(
              localStorage.getItem('appointmentId')
            )
            if (check) {
              if (check.isTemplateSend) {
                this.$router.replace(
                  `templateSend?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
                )
              }
              if (check.isTemplateSendSpecial) {
                this.$router.replace(
                  `templateSendSpecial?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
                )
              }
              localStorage.removeItem('checkMeeting')
              localStorage.removeItem('appointmentId')
              return
            }
            localStorage.removeItem('code')
            this.$router.replace('/').catch((err) => err)
          } else {
            this.$router.replace('bindCompany')
          }
        } else {
          let companyCode =
            localStorage.getItem('companyCode') &&
              JSON.parse(localStorage.getItem('companyCode')).code
              ? JSON.parse(localStorage.getItem('companyCode'))
              : { code: this.$route.query.companyCode }
          if (companyCode && companyCode.code) {
            this.companyCode = companyCode
            const companyInfo = await getCompanyInfo(companyCode.code)
            if (companyInfo.logo) {
              this.companyLogo = companyInfo.logo
            } else {
              this.companyLogo = require('@/assets/images/logo.png')
            }
          } else {
            this.ifCompanyCode = false
            this.companyLogo = require('@/assets/images/logo.png')
            return
          }
        }
      }
      getCode((code) => {
        dingAutoLogin(code)
      }, corpid)
    },
    async FSautoLogin(code, companyCode) {
      const res = await ovWxAutoLogin({
        companyCode: companyCode,
        fsOpenId: code,
      })
      if (res.id != -1) {
        localStorage.setItem('user', JSON.stringify(res))
        let companyCodeLocal = { code: companyCode }
        localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
        localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
        if (res.name) {
          let check = JSON.parse(localStorage.getItem('checkMeeting'))
          let appointmentId = JSON.parse(localStorage.getItem('appointmentId'))
          if (check) {
            if (check.isTemplateSend) {
              this.$router.replace(
                `templateSend?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
              )
            }
            if (check.isTemplateSendSpecial) {
              this.$router.replace(
                `templateSendSpecial?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
              )
            }
            localStorage.removeItem('checkMeeting')
            localStorage.removeItem('appointmentId')
            return
          }
          localStorage.removeItem('code')
          this.$router.replace('/').catch((err) => err)
        } else {
          this.$router.replace('bindCompany')
        }
      }
    },
    async vowxAutoLogin(vxcode, companyCode) {
      const res = await ovWxAutoLogin({
        companyCode: companyCode,
        qwWechatOpenId: vxcode,
      })
      if (res.id != -1) {
        localStorage.setItem('user', JSON.stringify(res))
        let companyCodeLocal = { code: companyCode }
        localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
        localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
        if (res.name) {
          let check = JSON.parse(localStorage.getItem('checkMeeting'))
          let appointmentId = JSON.parse(localStorage.getItem('appointmentId'))
          if (check) {
            if (check.isTemplateSend) {
              this.$router.replace(
                `templateSend?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
              )
            }
            if (check.isTemplateSendSpecial) {
              this.$router.replace(
                `templateSendSpecial?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
              )
            }
            localStorage.removeItem('checkMeeting')
            localStorage.removeItem('appointmentId')
            return
          }
          localStorage.removeItem('code')
          this.$router.replace('/').catch((err) => err)
        } else {
          this.$router.replace('bindCompany')
        }
      }
    },
    async wxAutoLogin(wechatOpenId) {
      let companyCode =
        JSON.parse(localStorage.getItem('companyCode')) &&
          JSON.parse(localStorage.getItem('companyCode')).code
          ? JSON.parse(localStorage.getItem('companyCode'))
          : { code: this.$route.query.companyCode }
      let res = await autoLogin({ companyCode: companyCode.code, wechatOpenId })
      if (res.id != -1) {
        localStorage.setItem('user', JSON.stringify(res))
        let companyCodeLocal = companyCode
        localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
        localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
        if (res.name) {
          let check = JSON.parse(localStorage.getItem('checkMeeting'))
          let appointmentId = JSON.parse(localStorage.getItem('appointmentId'))
          if (check) {
            if (check.isTemplateSend) {
              this.$router.replace(
                `templateSend?appointmentId=${appointmentId.id}&companyCode=${this.companyCode.code}`
              )
            }
            if (check.isTemplateSendSpecial) {
              this.$router.replace(
                `templateSendSpecial?appointmentId=${appointmentId.id}&companyCode=${this.companyCode.code}`
              )
            }
            localStorage.removeItem('checkMeeting')
            localStorage.removeItem('appointmentId')
            return
          }
          localStorage.removeItem('code')
          this.$router.replace('/').catch((err) => err)
        } else {
          this.$router.replace('bindCompany')
        }
      } else {
        res.wechatOpenId && (this.openId = res.wechatOpenId)
        localStorage.removeItem('code')
      }
    },
    async wutianAutoLogin(errcode, weChatEnterpriseCode, companyCode, errmsg) {
      const companyInfo = await getCompanyInfo(companyCode)
      const res = await autoLogin({
        errCode: errcode,
        weChatEnterpriseCode: weChatEnterpriseCode,
        companyId: companyInfo.id,
      })
      if (res.id != -1) {
        localStorage.setItem('errcode', JSON.stringify(errcode))
        localStorage.setItem('errmsg', JSON.stringify(errmsg))
        localStorage.setItem('user', JSON.stringify(res))
        let companyCodeLocal = { code: companyCode }
        localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
        localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
        if (res.name) {
          let check = JSON.parse(localStorage.getItem('checkMeeting'))
          let appointmentId = JSON.parse(localStorage.getItem('appointmentId'))
          if (check) {
            if (check.isTemplateSend) {
              this.$router.replace(
                `templateSend?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
              )
            }
            if (check.isTemplateSendSpecial) {
              this.$router.replace(
                `templateSendSpecial?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
              )
            }
            localStorage.removeItem('checkMeeting')
            localStorage.removeItem('appointmentId')
            return
          }
          localStorage.removeItem('code')
          this.$router.replace('/').catch((err) => err)
        } else {
          this.$router.replace('bindCompany')
        }
      }
    },
    async getCompanyInfoData(companyCode) {
      try {
        const companyInfo = await getCompanyInfo(companyCode)
        if (
          (companyInfo?.qwAppId && companyInfo?.qwAgentId) ||
          (companyInfo?.dingTalkSecret && companyInfo?.dingTalkKey) ||
          companyInfo?.fsAppId
        ) {
          this.showRegisterBtn = false
        } else {
          this.showRegisterBtn = true
        }
      } catch (error) {
        console.error(
          'getCompanyInfoData() Failed to fetch company info:',
          error
        )
      }
    },
  },
  computed: {
    codeLoginTest() {
      return this.mobileTest() === true && this.codeTest() === true
    },
    pwdLoginTest() {
      return this.pwdTest() === true
    },
    modelSms() {
      return (
        this.mobileTest() === true &&
        (this.smsTitle == this.$t('获取验证码') ||
          this.smsTitle == this.$t('重新获取'))
      )
    },
    smsColor() {
      return this.mobileTest() === true
    },
  },
  async created() {
    let state = this.$route.query.state
      ? this.$route.query.state
      : localStorage.getItem('state')
        ? JSON.parse(localStorage.getItem('state'))
        : undefined
    let companyCode = this.$route.query.companyCode
      ? this.$route.query.companyCode
      : JSON.parse(localStorage.getItem('companyCode')).code
    let vxcode = this.$route.query.code
      ? this.$route.query.code
      : localStorage.getItem('code')
        ? JSON.parse(localStorage.getItem('code')).code
        : undefined
    let type = this.$route.query.type
      ? this.$route.query.type
      : localStorage.getItem('type')
        ? JSON.parse(localStorage.getItem('type'))
        : undefined
    let appId = this.$route.query.appId
      ? this.$route.query.appId
      : localStorage.getItem('appId')
        ? JSON.parse(localStorage.getItem('appId'))
        : undefined
    let inDD = ifInDD()
    let corpId = localStorage.getItem('corpid')
      ? JSON.parse(localStorage.getItem('corpid'))
      : undefined
    let code = localStorage.getItem('code')
      ? JSON.parse(localStorage.getItem('code'))
      : undefined
    let errcode = this.$route.query.errcode
      ? this.$route.query.errcode
      : localStorage.getItem('errcode')
        ? JSON.parse(localStorage.getItem('errcode'))
        : undefined
    let errmsg = this.$route.query.errmsg
      ? this.$route.query.errmsg
      : localStorage.getItem('errmsg')
        ? JSON.parse(localStorage.getItem('errmsg'))
        : undefined
    let weChatEnterpriseCode = this.$route.query.code
      ? this.$route.query.code
      : localStorage.getItem('code')
        ? JSON.parse(localStorage.getItem('code')).code
        : undefined
    // 处理武田地址多一个?的情况
    const currentUrl = window.location.href;
    // 直接检查原始URL中是否包含 %3F（被转义的问号）
    const hasEncodedQuestionMark = currentUrl.includes('%3F');
    if (hasEncodedQuestionMark) {
      const decodedUrl = decodeURIComponent(currentUrl);
      // 找到第一个?
      const firstQuestionIndex = decodedUrl.indexOf('?');
      if (firstQuestionIndex === -1) return null;
      // 获取查询部分
      const queryPart = decodedUrl.substring(firstQuestionIndex + 1);
      // 查找第二个?（被转义的）
      const secondQuestionIndex = queryPart.indexOf('?');
      let companyCodeMsg, errcodeMsg;
      if (secondQuestionIndex !== -1) {
        // 提取companyCode（第一个?之前的参数）
        const beforeSecondQuestion = queryPart.substring(0, secondQuestionIndex);
        const companyCodeMatch = beforeSecondQuestion.match(/companyCode=([^&]*)/);
        companyCodeMsg = companyCodeMatch ? companyCodeMatch[1] : null;
        // 提取errcode（第二个?之后的参数）
        const afterSecondQuestion = queryPart.substring(secondQuestionIndex + 1);
        const errcodeMatch = afterSecondQuestion.match(/errcode=([^&]*)/);
        errcodeMsg = errcodeMatch ? errcodeMatch[1] : null;
      }
      // 提取其他参数
      companyCode = companyCodeMsg ? companyCodeMsg : null,
      errcode = errcodeMsg ? errcodeMsg : null
    }
    let ifLogout = localStorage.getItem('ifLogout')
    this.getCompanyInfoData(companyCode)
    this.companyCode = { code: companyCode } // 不管什么登录方式，先把 companyCode 放进去
    if (errcode == 0 && errmsg == 'ok' && weChatEnterpriseCode) {
      localStorage.removeItem('checkMeeting')
      localStorage.removeItem('appointmentId')
      this.wutianAutoLogin(errcode, weChatEnterpriseCode, companyCode, errmsg)
    }
    if (state && state.startsWith('WXwork')) {
      localStorage.removeItem('checkMeeting')
      localStorage.removeItem('appointmentId')
      this.vowxAutoLogin(vxcode, companyCode)
    } else if (corpId && inDD && !ifLogout) {
      localStorage.removeItem('checkMeeting')
      localStorage.removeItem('appointmentId')
      this.ifautoLogin(corpId.id, companyCode)
      this.corpId = corpId.id
    } else if (state && state == 'YongYou') {
      localStorage.removeItem('checkMeeting')
      localStorage.removeItem('appointmentId')
      this.ifYongYouLogin(vxcode, companyCode)
    } else if (state && state == 'fanwei') {
      localStorage.removeItem('checkMeeting')
      localStorage.removeItem('appointmentId')
      this.ifFanWeiLogin(companyCode)
    } else if (state && state == 'hudong') {
      localStorage.removeItem('checkMeeting')
      localStorage.removeItem('appointmentId')
      this.ifHuDongLogin(companyCode)
    } else {
      if (corpId && inDD) {
        localStorage.removeItem('checkMeeting')
        localStorage.removeItem('appointmentId')
        this.corpId = corpId.id
      }
      this.companyCode = { code: companyCode }
      if (code) {
        localStorage.removeItem('checkMeeting')
        localStorage.removeItem('appointmentId')
        this.wxcode = code.code
        if (!ifLogout) {
          this.wxAutoLogin(code.code)
        }
      }
    }
  },
  mounted() {
    localStorage.removeItem('ifLogout')
  },
  beforeDestroy() {
    localStorage.removeItem('checkMeeting')
    localStorage.removeItem('appointmentId')
  },
}
</script>
<style lang="less" scoped>
.loginForm {
  margin: 10px 8px 0px;

  .code-btn {
    background: none;
    border: none;
    font-size: 14px;
    display: flex;

    img {
      width: 16px;
      height: 16px;
    }
  }

  .login-btn {
    border: none;
    font-size: 16px;
  }

  .ml-auto {
    margin-left: auto;
  }

  .to-login {
    width: 100px;
    padding-left: 16px;
    height: 24px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
    margin-bottom: 32px;
    display: block;
  }

  .form-spacing {
    margin-top: 12px;
  }

  /deep/.form-spacing-code {
    .van-cell__value {
      border-bottom: 1px solid #ececec;
    }
  }

  .jumpBox {
    display: flex;
    justify-content: space-between;

    .to-findPwd {
      height: 24px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
      padding-right: 16px;
      margin-top: 8px;
      display: block;
      margin-bottom: 32px;
    }
  }

  .loginBox {
    width: 280px;
    height: 44px;
    margin: 0 40px;
  }
}

.error {
  height: 24px;
  font-size: 12px;
  color: #e02020;
  line-height: 24px;
  padding-left: 16px;
}

.errSpace {
  height: 67px;
  padding-bottom: 24px;
}
</style>
